const beforeItems = [
  { text: "Missed leads", icon: "ri-close-circle-line" },
  { text: "Manual processes", icon: "ri-close-circle-line" },
  { text: "Disconnected systems", icon: "ri-close-circle-line" },
  { text: "Reactive operations", icon: "ri-close-circle-line" },
];

const afterItems = [
  { text: "Captured opportunities", icon: "ri-checkbox-circle-line" },
  { text: "Automated workflows", icon: "ri-checkbox-circle-line" },
  { text: "Unified systems", icon: "ri-checkbox-circle-line" },
  { text: "Predictable growth", icon: "ri-checkbox-circle-line" },
];

export default function ComparisonSection() {
  return (
    <section className="w-full bg-[#0D0D10] py-28 px-6 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block text-xs font-semibold uppercase tracking-widest text-[#4ADE80]/80 mb-4">
            The Transformation
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-white"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Before vs After GroundsWell AI
          </h2>
        </div>

        {/* Comparison Card */}
        <div className="grid grid-cols-1 md:grid-cols-2 rounded-3xl overflow-hidden border border-white/8">
          {/* Before */}
          <div className="bg-[#140A0A] p-12 md:p-16 border-b md:border-b-0 md:border-r border-white/8 relative overflow-hidden">
            {/* Background texture */}
            <div className="absolute inset-0 opacity-5"
              style={{
                backgroundImage: "radial-gradient(circle at 30% 50%, rgba(248,113,113,0.4) 0%, transparent 60%)",
              }}
            />

            <div className="relative z-10">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-red-400/10 border border-red-400/20">
                  <i className="ri-close-line text-red-400 text-base" />
                </div>
                <h3
                  className="text-2xl font-bold text-red-300"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  Before
                </h3>
              </div>

              <div className="space-y-5">
                {beforeItems.map((item) => (
                  <div key={item.text} className="flex items-center gap-4">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-red-400 text-xl`} />
                    </div>
                    <span className="text-lg text-white/55">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* After */}
          <div className="bg-[#0A140A] p-12 md:p-16 relative overflow-hidden">
            {/* Background texture */}
            <div className="absolute inset-0 opacity-5"
              style={{
                backgroundImage: "radial-gradient(circle at 70% 50%, rgba(74,222,128,0.4) 0%, transparent 60%)",
              }}
            />

            <div className="relative z-10">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#4ADE80]/10 border border-[#4ADE80]/20">
                  <i className="ri-check-line text-[#4ADE80] text-base" />
                </div>
                <h3
                  className="text-2xl font-bold text-[#4ADE80]"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  After GroundsWell AI
                </h3>
              </div>

              <div className="space-y-5">
                {afterItems.map((item) => (
                  <div key={item.text} className="flex items-center gap-4">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-[#4ADE80] text-xl`} />
                    </div>
                    <span className="text-lg text-white/70">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
